import { theme } from '@ketch-com/deck'
import { Box, styled, Typography } from '@mui/material'
import {
  AuditLogHeaderActions,
  AuditLogHeaderActionsVariant,
} from 'pages/insights/auditLog/components/AuditLogHeaderActions'
import { NoDataEmptyState } from 'pages/insights/auditLog/components/NoDataEmptyState'
import { TopicItem } from 'pages/insights/auditLog/components/subscriptionsTab/components/TopicItem/TopicItem'
import { useAuditLogContext } from 'pages/insights/auditLog/context/AuditLogContext'

const SubscriptionsTabBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  width: '100%',
})

export const AuditLogSubscriptionsTab: React.FC = () => {
  const { subscriptionsData, topicSearch } = useAuditLogContext()

  // Counts use all subscriptions
  const activeSubscriptions = subscriptionsData.filter(topicChannels =>
    topicChannels.some(channel => channel.allowed),
  ).length
  const totalSubscriptions = subscriptionsData.length

  // Filters subscriptions by search string
  const filteredSubscriptions = subscriptionsData.filter(topicChannels => {
    const searchString = topicSearch.toLowerCase()

    if (!topicChannels[0]) return false

    return (
      topicChannels[0].name?.toLowerCase().includes(searchString) ||
      topicChannels[0].code?.toLowerCase().includes(searchString)
    )
  })

  return (
    <SubscriptionsTabBox>
      {/* Header */}
      <Typography variant="h3">
        {activeSubscriptions}
        <Typography variant="h3" component="span" color={theme.palette.Text.Secondary}>
          /{totalSubscriptions}
        </Typography>{' '}
        Active Subscriptions
      </Typography>

      {/* Bulk Actions */}
      <AuditLogHeaderActions variant={AuditLogHeaderActionsVariant.Subscriptions} />

      {/* Topics List */}
      {filteredSubscriptions.length ? (
        filteredSubscriptions.map(topicChannels => {
          if (!topicChannels.length) return null

          return <TopicItem key={topicChannels[0].code} channels={topicChannels} />
        })
      ) : (
        <NoDataEmptyState subtitle="There are no subscription topics with a name matching your search." />
      )}
    </SubscriptionsTabBox>
  )
}
